import { Text, VStack } from '@chakra-ui/react';

import { AskEddy } from '@/client/components/icons/ContinuIcons';
import OutlineButton from '@/client/components/shared/buttons/OutlineButton';
import { useExpertsStore } from '../expertsStore';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NoExpertsOverviewPlaceholder() {
  const { setIsEditingExpert } = useExpertsStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <VStack
      backgroundColor="neutral.0"
      border="1px solid"
      borderColor="neutral.100"
      borderRadius="16px"
      padding={8}
    >
      <AskEddy boxSize={28} marginBottom={6} />

      <VStack marginBottom={5}>
        <Text fontSize="16px" fontWeight={600} color="baseBlack">
          {t('admin.aiAgent.experts.noData.title')}
        </Text>

        <Text fontSize="14px" fontWeight={400} color="neutral.600">
          {t('admin.aiAgent.experts.noData.helpText')}
        </Text>
      </VStack>

      <OutlineButton
        width="fit-content"
        onClick={() => {
          setIsEditingExpert(true);
          navigate('/admin/eddy/experts/details');
        }}
      >
        {t('admin.aiAgent.experts.noData.buttonCopy')}
      </OutlineButton>
    </VStack>
  );
}
